import {ContentCommentReportReasonPutDataTransferObject} from "../../data-transfer-object/content/ContentCommentReportReasonPutDataTransferObject"

/**
 * 댓글 신고 사유 속성 설명
 */
export const ContentCommentReportReasonPutDataTransferObjectDescription: Record<keyof ContentCommentReportReasonPutDataTransferObject, string> = {
    body: '내용',
    displayOrder: '표시 순서'
}
